import React from "react";
import './KanziFadeTitle.css';

const KanziFadeTitle = () => {
    return (
      <div className="KCT-fade-images-container">
        <img src="/KanziCelebration/KanziShadowText.png" alt="Kanzi shadow text artwork" className="KCT-fade-img img1" />
        <img src="/KanziCelebration/KanziShadowSymbol.png" alt="Kanzi symbolic shadow artwork" className="KCT-fade-img img2" />
        <img src="/KanziCelebration/BonoboSapien.png" alt="Bonobo sapien tribute artwork" className="KCT-fade-img img3" />
      </div>
    );
  };

export default KanziFadeTitle;
